import { Link } from "react-router-dom";
import { ArrowUpRight, History } from "lucide-react";

const fmtPrice = (item) => {
  if (item.priceOnRequest) return "Enquire";
  return `${item.priceFrom ? "FROM " : ""}$${item.price?.toLocaleString("en-NZ")}`;
};

export const RecentlyViewedStrip = ({ items }) => {
  if (!items || items.length === 0) return null;

  return (
    <section
      data-testid="recently-viewed-strip"
      className="container-x pb-16 md:pb-20 border-t border-[var(--border-default)] pt-16 md:pt-20"
    >
      <div className="mb-8 flex items-center gap-3">
        <History size={16} className="text-[var(--brand-primary)]" />
        <div>
          <p className="overline mb-2">— Your History</p>
          <h2 className="font-display text-3xl md:text-4xl text-white">
            RECENTLY <span className="text-[var(--brand-primary)]">VIEWED.</span>
          </h2>
        </div>
      </div>
      <div className="flex gap-4 overflow-x-auto pb-2 -mx-1 px-1 snap-x snap-mandatory scrollbar-thin">
        {items.map((item, i) => (
          <Link
            key={item.path}
            to={item.path}
            data-testid={`recently-viewed-item-${i}`}
            className="group relative block overflow-hidden border border-[var(--border-default)] hover:border-[var(--brand-primary)] transition-colors shrink-0 w-[210px] sm:w-[230px] snap-start bg-[var(--bg-secondary)]"
          >
            <div className="aspect-[4/3] overflow-hidden relative">
              <img
                src={item.thumb}
                alt={item.name}
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/15 to-transparent" />
              <div className="absolute top-3 right-3 w-7 h-7 border border-white/30 flex items-center justify-center bg-black/40 backdrop-blur-sm group-hover:border-[var(--brand-primary)] group-hover:bg-[var(--brand-primary)] transition-colors">
                <ArrowUpRight size={12} className="text-white group-hover:text-black transition-colors" />
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <h3 className="font-display text-base text-white leading-tight line-clamp-2">{item.name}</h3>
                <p className="font-mono text-[10px] uppercase tracking-wider text-[var(--brand-primary)] mt-1.5">
                  {fmtPrice(item)}
                </p>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};
